import { InfoBanner } from '@ui';
import { ReviewStatus } from '@/api/apis/case';

export const TxCenterConfirmationBanner = ({
  approvalStatus,
  onDetailsClick,
}: {
  approvalStatus: ReviewStatus;
  onDetailsClick: () => void;
}) => {
  switch (approvalStatus) {
    case ReviewStatus.Approved:
      return (
        <InfoBanner iconType="success">
          NOP Service approved by TX Center.{' '}
          <button className="underline" onClick={onDetailsClick}>
            See details
          </button>
        </InfoBanner>
      );
    case ReviewStatus.Rejected:
      return (
        <InfoBanner iconType="cross">
          NOP Service rejected by TX Center.{' '}
          <button className="underline" onClick={onDetailsClick}>
            See details
          </button>
        </InfoBanner>
      );
    case ReviewStatus.WaitingForApproval:
      return <InfoBanner iconType="info">Waiting for NOP Service approval by TX Center</InfoBanner>;
    default:
      return null;
  }
};
